import { WorksheetImagesAndRemarksSection, WorksheetTestedBySection } from 'Components/Worksheets/Core';
import { ListFieldSection, PageSection, SectionGroup } from '../../../Layout';
import ids from '../../QestIds';

import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import {
  CompactionCwdSection,
  CompactionDataSection,
  CompactionEquipmentSection,
  CompactionWaterContentDeterminationEquipmentSection,
  TestFractionSpecificGravitySection,
} from '../Shared';
import {
  AstmPreparationSection,
  AstmResultsSection,
  CompactionWaterContentDeterminationGridSection,
  OversizeCorrectionSection,
  OversizeDeterminationSection,
} from './Sections';

const qestIds = [ids.maximumDryDensity.ASTM_D_1557.rev2012, ids.maximumDryDensity.ASTM_D_698.rev2012e2];

let AstmMddWorksheet = () => {
  return (
    <>
      <AstmPreparationSection />
      <OversizeDeterminationSection />
      <OversizeCorrectionSection />

      <NamePrefixModifier appendNamePrefix="TestFractionSpecificGravity">
        <TestFractionSpecificGravitySection />
      </NamePrefixModifier>

      <PageSection heading="Compaction">
        <CompactionEquipmentSection />
        <SectionGroup heading="Compaction Data">
          <CompactionCwdSection />
          <ListFieldSection name="TestPortions" /* for messages relating to test portions */ />
          <CompactionDataSection />
        </SectionGroup>
        <SectionGroup heading="Water Content Determination">
          <CompactionWaterContentDeterminationEquipmentSection />
          <CompactionWaterContentDeterminationGridSection />
        </SectionGroup>
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <AstmResultsSection />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AstmMddWorksheet.qestIds = qestIds;

export default AstmMddWorksheet;
